@if (loading) {
    <div class="loader-container">
        <c-spinner
            [color]="color"
            [loading]="true" />
    </div>
} @else {
    <ng-content></ng-content>
}